<template>
  <div class="container-fluid">
    <div class="my-2" v-if="exammarks.length <= 0">
      <div class="mt-5 text-center">
        <b-spinner type="grow" variant="primary" label="Loading"></b-spinner>
      </div>
    </div>
    <div v-else>
      <div v-for="item in exammarks" :key="item.id" class="reportCard">
        <div
          style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
        >
          <div class="d-flex justify-content-between">
            <div>
              <span v-if="item.school.logo != 0"
                ><img :src="getLogo(item.school.logo)" height="80"/><br
              /></span>
              <span v-else
                ><img src="@/assets/images/logo.png" height="80"/></span
              ><br />
            </div>
            <div>
              <img :src="getFiles(item.students.student_photo)" height="80" />
            </div>
          </div>
          <div>
            <div class="text-center">
              <h5 style="color:black" class="text-uppercase mb-0">
                {{ item.school.name }}
              </h5>
              <span style="color:black;font-size:12px"
                >Location : {{ item.school.location }}</span
              ><br />
              <span style="color:black;font-size:12px"
                >Telephone : {{ item.school.telephone }}</span
              ><br /><br />
              <span
                style="color: black;font-size:13px"
                class="text-uppercase text-decoration-underline"
                ><b> {{ term }} Report</b></span
              ><br />
            </div>
          </div>
          <div class="d-flex justify-content-evenly">
            <div class="text-uppercase">
              NAME : {{ item.students.first_name }}
              {{ item.students.last_name }} <br />
              CLASS : {{ student_class }}
            </div>
            <div>
              TERM : {{ term }} <br />
              YEAR : {{ $route.query.year }}
            </div>
          </div>

          <!-- Table with improved formatting -->
          <div class="row mt-3">
            <div class="col-md-10 mx-auto">
              <table class="table table-sm" style="border: 2px solid black;">
                <thead>
                  <tr
                    class="text-uppercase"
                    style="border-bottom: 2px solid black;"
                  >
                    <th>Subject</th>
                    <th>Marks</th>
                    <th>Grade</th>
                    <th>Aggregates</th>
                    <th>Comment</th>
                    <th>Initials</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="x in item.exammarks" :key="x.id">
                    <td>
                      <strong>{{ x.subjects[0].name }}</strong>
                    </td>
                    <td>
                      <strong>{{ x.mark[0].mark }}</strong>
                    </td>
                    <td>
                      <strong>{{
                        getGradeFromAggregate(x.mark[0].aggregates)
                      }}</strong>
                    </td>
                    <td>
                      <strong>{{ x.mark[0].aggregates }}</strong>
                    </td>
                    <td>
                      <span v-if="x.mark[0].aggregates == '1'">EXCELLENT</span>
                      <span v-else-if="x.mark[0].aggregates == '2'"
                        >V.GOOD</span
                      >
                      <span v-else-if="x.mark[0].aggregates == '3'">GOOD</span>
                      <span v-else-if="x.mark[0].aggregates == '4'">GOOD</span>
                      <span v-else-if="x.mark[0].aggregates == '5'">FAIR</span>
                      <span v-else-if="x.mark[0].aggregates == '6'"
                        >AIM HIGHER</span
                      >
                      <span v-else-if="x.mark[0].aggregates == '7'"
                        >WORK HARDER</span
                      >
                      <span v-else-if="x.mark[0].aggregates == '8'"
                        >IMPROVE</span
                      >
                      <span v-else>POOR</span>
                    </td>
                    <td>
                      <strong>{{
                        Initials(x.teacher ? x.teacher.full_name : "")
                      }}</strong>
                    </td>
                  </tr>
                  <tr
                    class="text-uppercase font-weight-bold bg-light"
                    style="border-top: 2px solid black;"
                  >
                    <td><strong>TOTAL</strong></td>
                    <td>
                      <strong>{{ item.total }}</strong>
                    </td>
                    <td colspan="2">
                      <strong>AGGREGATES: {{ item.aggregates }}</strong>
                    </td>
                    <td colspan="2">
                      DIVISION :
                      <strong>
                        <span v-if="item.aggregates <= '12'">DI</span>
                        <span v-else-if="item.aggregates <= '23'">DII</span>
                        <span v-else-if="item.aggregates <= '29'">DIII</span>
                        <span v-else-if="item.aggregates <= '34'">DIV</span>
                        <span v-else>U</span>
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--z<div class="d-flex justify-content-between mt-2">
            <div>
              <h5 class="text-uppercase">Class Teacher</h5>
              <br />
              <span
                >Comment:
                <span class="text-uppercase">{{
                  getCommentForAggregate(
                    getLastExamSetAggregates(item.examSets),
                    comment_groups,
                    1,
                  )
                }}</span></span
              ><br />
              <span class="signature-line">
                Signature :
                <span v-if="getSignatureForStatus(comment_groups, 1)">
                  <img
                    :src="getSignatureForStatus(comment_groups, 1)"
                    height="30"
                    alt="Class Teacher Signature"
                  />
                </span>
                <span v-else
                  >................................................</span
                >
              </span>
            </div>
            <div>
              <h5 class="text-uppercase">Head Teacher</h5>
              <br />
              <span
                >Comment:
                <span class="text-uppercase">{{
                  getCommentForAggregate(
                    getLastExamSetAggregates(item.examSets),
                    comment_groups,
                    2,
                  )
                }}</span></span
              ><br />
              <span class="signature-line">
                Signature :
                <span v-if="getSignatureForStatus(comment_groups, 2)">
                  <img
                    :src="getSignatureForStatus(comment_groups, 2)"
                    height="30"
                    alt="Head Teacher Signature"
                  />
                </span>
                <span v-else
                  >..................................................</span
                >
              </span>
            </div>
          </div>-->
          <!-- Improved Teacher Comments Section -->
          <div class="d-flex justify-content-between mt-4">
            <div class="text-center">
              <h5 class="text-uppercase mb-2">Class Teacher :</h5>
              <div>
                <span class="text-uppercase">
                  {{
                    getCommentForAggregate(item.aggregates, comment_groups, 1)
                  }}
                </span>
              </div>
              <div class="signature-line mt-3">
                <span>Signature :</span><br />
                <span>..................................................</span>
              </div>
            </div>
            <div class="text-center">
              <h5 class="text-uppercase mb-2">Head Teacher :</h5>
              <div>
                <span class="text-uppercase">
                  {{
                    getCommentForAggregate(item.aggregates, comment_groups, 2)
                  }}
                </span>
              </div>
              <div class="signature-line mt-3">
                <span>Signature :</span><br />
                <span>..................................................</span>
              </div>
            </div>
          </div>

          <div class="mt-4 text-center">
            <span
              ><strong>Next Term Begins on:</strong>
              <span class="text-uppercase">
                {{ next_term }}
              </span>
            </span>
          </div>

          <!-- Grading Table with improved styling -->
          <div class="row mt-4">
            <div class="col-md-10 mx-auto">
              <div class="mt-4">
                <h5 class="text-center mb-3">GRADING SYSTEM</h5>
                <table class="table table-sm grading-table" border="3">
                  <thead>
                    <tr>
                      <th>D1</th>
                      <th>D2</th>
                      <th>C3</th>
                      <th>C4</th>
                      <th>C5</th>
                      <th>C6</th>
                      <th>P7</th>
                      <th>P8</th>
                      <th>F9</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="x in item.grading" :key="x.id">
                      <td>{{ x.d1 }}</td>
                      <td>{{ x.d2 }}</td>
                      <td>{{ x.c3 }}</td>
                      <td>{{ x.c4 }}</td>
                      <td>{{ x.c5 }}</td>
                      <td>{{ x.c6 }}</td>
                      <td>{{ x.p7 }}</td>
                      <td>{{ x.p8 }}</td>
                      <td>{{ x.f9 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";

export default {
  page: {
    title: "Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      year: "",
      full_name: "",
      exammarks: [],
      comment_groups: [],
    };
  },
  mounted() {
    this.FilterData();
  },
  methods: {
    // Convert aggregate number to grade letter (D1, D2, C3, etc.)
    getGradeFromAggregate(aggregate) {
      if (!aggregate) return "";

      const agg = parseInt(aggregate);

      if (agg === 1) return "D1";
      if (agg === 2) return "D2";
      if (agg >= 3 && agg <= 6) return `C${agg}`;
      if (agg >= 7 && agg <= 8) return `P${agg}`;
      if (agg === 9) return "F9";

      return aggregate.toString();
    },

    Initials(speaker) {
      if (!speaker) return "";
      const name = speaker.split(" ");
      return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ""}`;
    },

    getLogo(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },

    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },

    FilterData() {
      let formData = new FormData();
      formData.append("student_id", this.$route.query.student);
      formData.append("school", this.$route.query.school);
      formData.append("schoolterm", this.$route.query.term);
      formData.append("year", this.$route.query.year);
      formData.append("schoolclass", this.$route.query.class);

      let url = "/viewreport";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.markss || [];
        this.next_term = response.data.next_term || "To be announced";
        this.term = response.data.term;
        this.student_class = response.data.student_class;
      });

      // Get comment groups for the class
      axios
        .get(
          `/appcomment-group/${this.$route.query.school}/${this.$route.query.class}`,
        )
        .then((response) => {
          if (response.status == 200) {
            this.comment_groups = response.data.comment_groups;
          }
        });
    },

    getCommentForAggregate(aggregate, comment_groups, status) {
      const agg = parseInt(aggregate);

      if (!comment_groups || comment_groups.length === 0) {
        return "No comment available";
      }

      // loop through comment groups and find the matching range
      for (let group of comment_groups) {
        const start = parseInt(group.start_agg);
        const end = parseInt(group.end_agg);
        if (group.status == status && agg >= start && agg <= end) {
          return group.comment;
        }
      }
      return "No comment available";
    },

    // Format date nicely
    formatDate(dateString) {
      if (!dateString) return "To be announced";

      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
          case 1:
            return `${day}st`;
          case 2:
            return `${day}nd`;
          case 3:
            return `${day}rd`;
          default:
            return `${day}th`;
        }
      };

      return `${getDaySuffix(day)} ${month} ${year}`;
    },

    FilterBy() {},
  },
};
</script>

<style>
@media print {
  .reportCard {
    page-break-before: always;
    page-break-inside: avoid;
  }
}

table {
  border: 2px solid black !important;
}

th,
td {
  border: 1px solid black;
  padding: 8px;
  border-collapse: collapse;
}

.grading-table th,
.grading-table td {
  text-align: center;
  font-weight: bold;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.font-weight-bold {
  font-weight: bold !important;
}

.comment-box {
  min-height: 40px;
  padding: 5px;
  border: 1px solid #000;
  width: 200px;
  display: inline-block;
  margin-top: 5px;
}

/* .signature-line {
  margin-top: 20px;
} */

/* Ensure consistent styling */
.text-uppercase {
  text-transform: uppercase !important;
}
</style>
